<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="className">
    <path d="M5 18H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h11v12" />
    <path d="M14 9h4l4 4v4a1 1 0 0 1-1 1h-2" />
    <circle cx="7" cy="18" r="2" />
    <circle cx="17" cy="18" r="2" />
  </svg>
</template>

<script>
export default {
  name: 'IconTruck',
  props: { className: { type: String, default: 'w-5 h-5' } },
}
</script>

